import React, { useState, useCallback, useEffect } from "react";
import "./App.css";
import { motion, useScroll, useSpring } from "framer-motion";
import LoadingScreen from "./components/LoadingScreen";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import WhyUsSection from "./components/WhyUsSection";
import ServicesSection from "./components/ServicesSection";
import TechSection from "./components/TechSection";
import HowItWorksSection from "./components/HowItWorksSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";
import { LanguageProvider } from './context/LanguageContext';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_site-craft-423/artifacts/i72kt4ww_image.jpg";

const ParticlesBackground = () => {
  const particles = Array.from({ length: 15 }, (_, i) => ({
    id: i,
    left: `${Math.random() * 100}%`,
    delay: Math.random() * 15,
    duration: 12 + Math.random() * 18,
    size: 1 + Math.random() * 2.5,
    opacity: 0.08 + Math.random() * 0.2,
  }));

  return (
    <div className="particles-container">
      {particles.map((p) => (
        <div
          key={p.id}
          className="particle"
          style={{
            left: p.left,
            bottom: '-5px',
            width: `${p.size}px`,
            height: `${p.size}px`,
            opacity: p.opacity,
            animationDelay: `${p.delay}s`,
            animationDuration: `${p.duration}s`,
          }}
        />
      ))}
    </div>
  );
};

const ScrollProgress = () => {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001,
  });

  return (
    <motion.div
      className="scroll-progress"
      style={{ scaleX, transformOrigin: "right" }}
    />
  );
};

function App() {
  const [isLoading, setIsLoading] = useState(true);

  const handleLoadingFinish = useCallback(() => {
    setIsLoading(false);
  }, []);

  useEffect(() => {
    const img = new Image();
    img.src = LOGO_URL;
  }, []);

  return (
    <LanguageProvider>
      <div className="App">
        {isLoading && <LoadingScreen onFinish={handleLoadingFinish} logoUrl={LOGO_URL} />}
        {!isLoading && (
          <>
            <ScrollProgress />
            <ParticlesBackground />
            <Navbar logoUrl={LOGO_URL} />
            <main style={{ position: 'relative', zIndex: 1 }}>
              <HeroSection logoUrl={LOGO_URL} />
              <WhyUsSection />
              <ServicesSection />
              <TechSection />
              <HowItWorksSection />
              <ContactSection />
            </main>
            <Footer logoUrl={LOGO_URL} />
          </>
        )}
      </div>
    </LanguageProvider>
  );
}

export default App;
